<template>
    <v-card flat class="pa-5">
        <h1 class="fonte text-uppercase">Escolha o template da sua mensagem</h1>


            <v-layout row justify-space-between wrap>
                <v-flex xs4>
                    <v-card class="ma-3" width="450">
                        <!--<div
                            is="layout"
                            style="height: 800px; overflow: auto;"

                            :head.sync="template.head"
                            :logo.sync="template.logo"
                            :texto.sync="template.texto"
                            :contato.sync="template.contato"
                            :botoes.sync="template.botoes"

                        ></div>-->
                    </v-card>
                </v-flex>
                <v-flex xs6 class="ma-3">

                    <div class="ma-3">
                        <v-text-field class="mb-3" box v-model="template.head.logo" color="teal" label="Cole o endereço de outra imagem para a logo do menu"></v-text-field>
                        <v-text-field class="mb-3" box v-model="template.head.titulo" color="teal" label="Digite o Título"></v-text-field>
                        <v-text-field class="mb-3" box v-model="template.logo.src" color="teal" label="Cole o endereço de outra imagem para a logo"></v-text-field>
                        <v-textarea class="mb-3" box label="Digite seu texto" color="teal" v-model="template.texto" persistent-hint hint="Favor utilizar pontuação de forma correta para manter o layout."></v-textarea>
                        <v-text-field class="mb-3" box v-model="template.contato" color="teal" label="Digite o texto do rodapé"></v-text-field>



                        <!--<v-select label="Selecione o seu layout (tema)" box :items="layouts" item-text="text" item-value="value" @change="selecionaLayout($event)"></v-select>-->
                    </div>
                    <v-btn class="ml-4" round large color="fundo" @click="exibeTemplate">Teste de Layout</v-btn>
                </v-flex>
            </v-layout>
    </v-card>

</template>

<script>
//import layout from './layout/layout.vue'
export default {
    /*components: {
        layout
    },*/
    data(){
        return{
            template: {
                head:{
                    title: "Agencia 56k",
                    color:"#00897B",
                    titulo: 'Teste',
                    logo: 'https://user-images.githubusercontent.com/7110136/29002857-9e802f08-7ab4-11e7-9c31-604b5d0d0c19.png'
                },
                logo:{
                    src:"https://www.fullstackpython.com/img/logos/vuejs-wide.png",
                    alt:"logo"
                },
                contato: `&copy;2018 — <strong>Vuetify</strong>`,
                texto: "Desenvolvemos soluções para empresas que utilizam tecnologia para o atendimento ao cliente e necessitam de algum tipo de aplicação ou solução na área de tecnologia da informação, nas áreas de telefonia fixo e móvel.",
                botoes: {
                    btn1:{
                        color: "#00897B",
                        label:"Abrir site",
                        link:"https://www.google.com/search?q=logo+png+vuejs&source=lnms&tbm=isch&sa=X&ved=0ahUKEwiL7qi5svXhAhUk1VkKHbTdAQAQ_AUIDigB&biw=1440&bih=828#imgrc=Zp6VNYlGNgVN6M:"
                    },

                    btn2:{
                        color: '#ff5252',
                        label:"Cancelar",
                        link:"https://dash-root.56k.com.br/#/"
                    },
                },
                socialnetwork:[
                {
                    src:"https://brasilparkshopping.com.br/img/facebook2.png",
                    alt:"facebook",
                    link:"https://www.facebook.com/"
                },
                {
                    src:"https://logodownload.org/wp-content/uploads/2015/04/whatsapp-logo-1.png",
                    alt:"whatsapp",
                    link:"https://api.whatsapp.com/send?phone=5516997659374&text=salve&source=&data="
                },
                {
                    src:"http://www.stickpng.com/assets/images/58e9196deb97430e819064f6.png",
                    alt:"twitter",
                    link:"https://twitter.com"
                },
                {
                    src:"http://www.stickpng.com/assets/images/58e9196deb97430e819064f6.png",
                    alt:"twitter",
                    link:"https://twitter.com"
                }
                ]
            }
        }
    },
    methods: {
        exibeTemplate()
            {
                //console.log(this.template)
            },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/mensagens/Templates.vue